// extracted by mini-css-extract-plugin
export default {"scroll":"ScrollButton_scroll__XytaT","line":"ScrollButton_line__zovhM","arrowsDown":"ScrollButton_arrowsDown__Ks83h","arrowsDownSmall":"ScrollButton_arrowsDownSmall__Sqwvw"};